import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVeselka = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_3",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 107.9 120.9",
	style: { enableBackground: "new 0 0 107.9 120.9" },
	xmlSpace: "preserve",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n    .st0 {\n      fill: #FF5117;\n    }\n\n    .st1 {\n      fill: #FF8E00;\n    }\n\n    .st2 {\n      fill: #F9D81E;\n    }\n\n    .st3 {\n      fill: #97CC37;\n    }\n\n    .st4 {\n      fill: #00C0E9;\n    }\n\n    .st5 {\n      fill: #8177FA;\n    }\n  "
	}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M15.2,85.2c7.6-29.3,24.1-48,46-60.4c20-11.3,45.3-13.2,46.6-13.2c0-4.6-0.2-10.4-0.8-11.2 c-1-1.3-45.3-1.6-80.5,37.2c-33.3,36.7-25.9,82.6-25.3,83c0.6,0.4,10.6,0.2,11.7,0.2C12.8,119.3,11.7,98.6,15.2,85.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M107.8,11.6c-1.3,0-26.6,1.9-46.6,13.2c-21.9,12.4-38.4,31.1-46,60.4c-3.5,13.4-2.4,34.1-2.3,35.6 c0,0.1,0,0.1,0,0.1h12.9l0.1-0.1h-0.2c0,0-0.5-8.4,0.6-19.4c1-9.4,3.2-20.5,8.1-29.9c5.7-11,16.1-27.7,34.9-36.8 c14.1-6.8,25.2-9.5,31.7-10.5c4.4-0.7,6.8-0.7,6.8-0.7v0.2l0.1-0.1L107.8,11.6C107.9,11.6,107.9,11.6,107.8,11.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st2",
			d: "M101,24.2c-6.6,1-17.7,3.7-31.7,10.5c-18.8,9.1-29.2,25.8-34.9,36.8c-4.8,9.4-7.1,20.5-8.1,29.9 c-1.2,11-0.6,19.4-0.6,19.4h0.2h12.2c0,0-1-7.7,0.6-18.8c0.8-5.4,2.1-11.5,4.4-17.9c2.7-7.5,6.7-15.3,12.7-22.8 C64.2,50.8,75,44.7,84.6,41.2c2.4-0.9,4.7-1.6,6.9-2.2c8.8-2.4,15.5-2.7,16.4-2.7V23.7v-0.2C107.8,23.5,105.4,23.5,101,24.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st3",
			d: "M107.8,36.3c-0.9,0-7.5,0.3-16.4,2.7c-2.2,0.6-4.5,1.3-6.9,2.2c-9.6,3.5-20.4,9.6-28.8,20.1 c-6,7.5-10,15.3-12.7,22.8c-2.3,6.4-3.7,12.6-4.4,17.9c-1.6,11.1-0.6,18.8-0.6,18.8h0.2h12c0,0-1-6.7,0-15.9 c1.2-11.1,5.1-25.9,17-37.4c9.7-9.3,19-14,26.2-16.4c8.6-2.8,14.3-2.3,14.4-2.3V36.3C107.9,36.3,107.9,36.3,107.8,36.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st4",
			d: "M93.5,51.1c-7.2,2.4-16.5,7.1-26.2,16.4c-11.9,11.5-15.9,26.3-17,37.4c-1,9.2,0,15.9,0,15.9h1.8h9 c0,0-0.7-8.3,1.3-18.7C64,93.7,67.4,84,74.2,76.3c6.8-7.6,14.1-11.8,20.2-14.2c7.7-2.9,13.4-2.8,13.4-2.8s0,1.8,0.1,4l0,0V51v-2.2 C107.8,48.8,102.1,48.3,93.5,51.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st5",
			d: "M107.9,63.3c0-2.2-0.1-4-0.1-4s-5.7-0.1-13.4,2.8c-6.1,2.3-13.4,6.5-20.2,14.2C67.4,84,64,93.7,62.4,102.1 c-2,10.4-1.3,18.7-1.3,18.7s10.5,0.3,10.9-0.5c0.9-1.7-2.9-21.7,9.6-35.9c13.1-14.6,25.4-12.5,25.8-13.1 C107.8,70.6,107.9,66.5,107.9,63.3z"
		})
	] })]
});
export default SvgVeselka;
